<script>
  import ProtectedRoute from "../components/ProtectedRoute.svelte";
</script>

<ProtectedRoute>
  <h1>protected route test</h1>
</ProtectedRoute>
